module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-dedication element-without-heading",
    attrs: {
      "epub:type": "dedication",
      "id": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "dedication-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width dedication-content"
  }, [_vm._v("This book is dedicated to two of my greatest encouragers, Rita Wilkinson, a lady I met when speaking at a WI meeting who has been a constant source of encouragement. Thank you, Rita for your support.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq dedication-content"
  }, [_vm._v("And also, at the other side of the world, Kelly Ferret, a lady whose enthusiasm and messages lift my spirits. I’ll try to write more quickly for you, Kelly!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0